export default __webpack_public_path__ + "static/media/premium-badge.c3f35201.svg";